<template>
  <div id="addEmployee" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-6 pb-0">
      <v-row no-gutters class="titulo"
        >Cargar datos para CFDI de empleados</v-row
      >
      <v-row no-gutters class="datos">
        <v-col class="py-2 mt-9" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="enterprise">Empresa Pagadora</label>
            <select name="enterprise" id="enterprise" v-model="enterprise">
              <option disabled value="0">Selecciona empresa</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="my-5"
          >Datos</v-col
        >
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeContract">Tipo de Contrato</label>
            <select name="typeContract" id="typeContract" v-model="contract">
              <option selected disabled value="0">Selecciona Contrato</option>
              <option
                v-for="contract in contracts"
                :key="contract.id"
                v-bind:value="contract.id"
              >
                {{ contract.tipoContrato }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="typeDay">Tipo de Jornada</label>
            <select name="typeDay" id="typeDay" v-model="day">
              <option disabled value="0">Selecciona Jornada</option>
              <option v-for="day in days" :key="day.id" v-bind:value="day.id">
                {{ day.nombreJornada }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="risk">Riesgo del Puesto</label>
            <select name="risk" id="risk" v-model="risk">
              <option disabled value="0">Selecciona Riesgo</option>
              <option
                v-for="risk in risks"
                :key="risk.id"
                v-bind:value="risk.id"
              >
                {{ risk.nombreRiesgo }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="union">Sindicalizado</label>
            <select name="union" id="union" v-model="union">
              <option disabled value="0">Selecciona Sindicalizado</option>
              <option selected value="1">Si</option>
              <option value="2">No</option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="regime">Tipo de Regimen</label>
            <select name="regime" id="regime" v-model="regime">
              <option disabled value="0">Selecciona Regimen</option>
              <option
                v-for="regime in regimes"
                :key="regime.id"
                v-bind:value="regime.id"
              >
                {{ regime.nombreRegimen }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col class="py-2" cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
          <div class="form-group inputEnterpriseL">
            <label for="periodicity">Periodicidad de Pago</label>
            <select name="periodicity" id="periodicity" v-model="periodicity">
              <option disabled value="0">Selecciona Periodicidad</option>
              <option
                v-for="periodicity in periodicities"
                :key="periodicity.id"
                v-bind:value="periodicity.id"
              >
                {{ periodicity.nombrePeriodicidad }}
              </option>
            </select>
          </div>
        </v-col>
        <v-col cols="12" sm="12" class="mt-11">
          <div class="form-group text-center terminos mt-4">
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="regresar()"
            >
              Regresar
            </button>
            <button
              class="boton ml-12"
              style="float: none !important"
              @click="validacion()"
            >
              Guardar
            </button>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!--Error-->
    <v-dialog v-model="error" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-sm-center text-lg-center">
            {{ respuesta }}
          </h3>
          <br />
          <ul>
            <li v-for="error in errors" :key="error.name">{{ error }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="error = false">Corregir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Validación de datos-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-md-center text-lg-center text-sm-center">
            {{ respuesta }}
          </h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="cancelar()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="guardar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">{{ message }}</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="aux()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "6-N",
      show: false,
      error: false,
      errors: [],
      respuesta: "",
      enterprises: [],
      enterprise: 0,
      dataCfdi: false,
      dataEmpleado: false,
      //dialogs de empleado
      confirmation: false,
      advice: false,
      //Data CFDI
      union: 2,
      //Arrays para CFDI
      contracts: [],
      contract: 0,
      days: [],
      day: 0,
      risks: [],
      risk: 0,
      regimes: [],
      regime: 0,
      periodicities: [],
      periodicity: 0,
      message: "",
      branch: 0,
      branches: [],
      estructura: 0,
      carga: 0,
      cargas: [
        {
          id: 1,
          nombre: "Manual",
        },
        {
          id: 2,
          nombre: "Automatica",
        },
      ],
    };
  },
  methods: {
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$"); // Letras y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57) {
        evt.preventDefault();
      } else return true;
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    validaCurp() {
      var strCorrecta = this.curp;
      if (strCorrecta.length === 18) {
        return true;
      } else {
        this.errors.push("El CURP esta incompleto favor de verificarlo.");
        return false;
      }
    },
    listarPeriodicidad() {
      this.show = true;
      axios
        .get(Server + "/periodicidadesPago", {
          headers: {
            Authorization: localStorage.token,
          },
        })
        .then((response) => {
          //console.log(response);
          this.periodicities = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          if (e.response.status == 401) {
            this.expiration = true;
          }
        });
    },
    listarRegimen() {
      this.show = true;
      axios
        .get(Server + "/regimen", {
          headers: {
            Authorization: localStorage.token,
          },
        })
        .then((response) => {
          this.regimes = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          if (e.response.status == 401) {
            this.expiration = true;
          }
        });
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.show = false;
          this.enterprises = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    listarPeriodicidad() {
      this.show = true;
      axios
        .get(Server + "/periodicidadesPago")
        .then((response) => {
          this.show = false;
          this.periodicities = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarRegimen() {
      this.show = true;
      axios
        .get(Server + "/regimen")
        .then((response) => {
          this.show = false;
          this.regimes = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    regresar() {
      this.$router.push("/employeesList");
    },
    listarContratos() {
      this.show = true;
      axios
        .get(Server + "/contratos")
        .then((response) => {
          this.show = false;
          this.contracts = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    listarJornadas() {
      this.show = true;
      axios
        .get(Server + "/jornadas")
        .then((response) => {
          this.show = false;
          this.days = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
      this.show = true;
      axios
        .get(Server + "/riesgosPuesto")
        .then((response) => {
          this.show = false;
          this.risks = response.data;
        })
        .catch((e) => {
          this.show = false;
          console.log(e);
        });
    },
    validacion() {
      this.errors = [];
      this.message = "CFDI para Empleados";
      if (this.enterprise == "" || this.enterprise == 0) {
        this.errors.push("Se debe especificar la empresa pagadora.");
      }
      if (this.contract == "" || this.contract == 0) {
        this.errors.push("Se debe especificar el tipo de contrato.");
      }
      if (this.day == "" || this.day == 0) {
        this.errors.push("Se debe especificar el tipo de jornada.");
      }
      if (this.risk == "" || this.risk == 0) {
        this.errors.push("Se debe especificar el riesgo del puesto.");
      }
      if (this.union == "" || this.union == 0) {
        this.errors.push("Se debe especificar el sindicato.");
      }
      if (this.regime == 0 || this.regime == "") {
        this.errors.push("Se debe especificar el régimen.");
      }
      if (this.periodicity == "" || this.periodicity == 0) {
        this.errors.push("Se debe especificar la periodicidad del pago.");
      }
      if (this.errors.length == 0) {
        this.message = "Alerta";
        this.respuesta = "Esta seguro de la almacenar la información.";
        this.advice = true;
      } else {
        if (this.errors.length > 2) {
          this.respuesta = "Por favor corrige los siguientes errores:";
          this.error = true;
        } else {
          this.respuesta = "Por favor corrige el siguiente error:";
          this.error = true;
        }
      }
    },
    cancelar() {
      this.$router.push("/employeesList");
    },
    guardar() {
      this.advice = false;
      this.errors = [];
      this.show = true;
      axios
        .post(
          Server + "/empleados/instalador/asignar-cfdi/" + this.enterprise,
          {
            //.post(Server + "/empleados/instalador", {
            ContratoId: this.contract,
            JornadaId: this.day,
            Sindicalizado: this.union == 0 ? false : true,
            RegimenId: this.regime,
            PeriodicidadPagoId: this.periodicity,
            RiesgoId: this.risk,
          }
        )
        .then((response) => {
          this.show = false;
          this.message = "Confirmación";
          this.respuesta = "CFDi almacenado con éxito";
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.message = "CFDI para empleados";
          this.errors.push("Por favor intentar más tarde.");
          this.respuesta =
            "Se obtuvo un error al tratar de almacenar la información:";
          this.error = true;
        });
    },
    aux() {
      this.confirmation = false;
      this.$router.push("/employeesList");
    },
  },
  created() {
    this.listarPeriodicidad();
    this.listarRegimen();
    this.nombre();
    this.listar();
    this.listarContratos();
    this.listarJornadas();
  },
};
</script>
